module.exports = __webpack_public_path__ + "static/img/305_TO8_2287.0e61980.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/305_TO8_2287.jpg
// module id = P/Ye
// module chunks = 0